import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bf986bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex gap-4 align-items-center" }
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  style: {"height":"250px"},
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "d-flex gap-3 justify-content-between" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "info" }
const _hoisted_10 = { class: "d-flex gap-3 justify-content-between mt-4" }
const _hoisted_11 = { class: "info d-flex align-items-center gap-2" }
const _hoisted_12 = { class: "mt-1" }
const _hoisted_13 = { class: "info" }
const _hoisted_14 = { class: "dialog-footer" }

import { ref } from "vue";
import { Refresh, CircleCheck, CircleClose } from "@element-plus/icons-vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import svc from "../../services/PaymentService";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountInfo',
  setup(__props, { expose: __expose }) {

const dialogRef = ref(false);
const data = ref<any>({});
const canTransferAmount = ref(0);
const isLoading = ref(false);
const criteria = ref<any>({
  id: null,
});

const refreshData = async () => {
  isLoading.value = true;
  try {
    const res = await svc.queryTransactions(criteria.value);
    if (res && res.data && res.data.length > 0) {
      data.value = res.data[0];
      setTransferAmount();
    }
  } catch (e) {
    console.log("Error fetching transaction data:", e);
  }
  isLoading.value = false;
};

const setTransferAmount = async () => {
  canTransferAmount.value =
    data.value.sourceAccountEquity -
    data.value.sourceAccountCredit -
    data.value.sourceAccountMargin;

  canTransferAmount.value = Number(canTransferAmount.value.toFixed(2));
  criteria.value.id = data.value.id;
};

const show = (_data: any) => {
  dialogRef.value = true;
  data.value = _data;
  setTransferAmount();
  console.log("canTransferAmount", canTransferAmount.value);
  console.log("data.amount", data.value.amount);
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_BalanceShow = _resolveComponent("BalanceShow")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogRef).value = $event)),
    width: "600",
    "align-center": ""
  }, {
    header: _withCtx(({ titleId, titleClass }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h4", {
          id: titleId,
          class: _normalizeClass(titleClass)
        }, _toDisplayString(_ctx.$t("fields.accountInformation")) + " - " + _toDisplayString(data.value.sourceAccountId), 11, _hoisted_2),
        _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          circle: "",
          type: "success",
          plain: "",
          onClick: refreshData
        }, null, 8, ["icon"])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogRef.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(ScaleLoader, { color: '#ffc730' })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t("fields.equity")), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_BalanceShow, {
                    balance: data.value.sourceAccountEquity * 100,
                    "currency-id": data.value.currencyId
                  }, null, 8, ["balance", "currency-id"])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t("fields.credit")), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_BalanceShow, {
                    balance: data.value.sourceAccountCredit * 100,
                    "currency-id": data.value.currencyId
                  }, null, 8, ["balance", "currency-id"])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t("fields.margin")), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_BalanceShow, {
                    balance: data.value.sourceAccountMargin * 100,
                    "currency-id": data.value.currencyId
                  }, null, 8, ["balance", "currency-id"])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t("fields.balance")), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_BalanceShow, {
                    balance: data.value.sourceAccountBalanceInCents,
                    "currency-id": data.value.currencyId
                  }, null, 8, ["balance", "currency-id"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t("tip.amountAvailable")), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createTextVNode(_toDisplayString(data.value.sourceAccountEquity) + " - " + _toDisplayString(data.value.sourceAccountCredit) + " - " + _toDisplayString(data.value.sourceAccountMargin) + " = " + _toDisplayString(canTransferAmount.value) + " ", 1),
                  _createElementVNode("div", _hoisted_12, [
                    (canTransferAmount.value * 100 >= data.value.amount)
                      ? (_openBlock(), _createBlock(_component_el_icon, {
                          key: 0,
                          color: "green"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CircleCheck))
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_icon, {
                          key: 1,
                          color: "red"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CircleClose))
                          ]),
                          _: 1
                        }))
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t("title.transferOutAmount")), 1),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_BalanceShow, {
                    balance: data.value.amount,
                    "currency-id": data.value.currencyId
                  }, null, 8, ["balance", "currency-id"])
                ])
              ])
            ])
          ]))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})